module.exports = __webpack_public_path__ + "static/media/_GPX0517.f06acfdd.jpeg";